import React from 'react'
import {BrowserRouter as Router, Route, NavLink} from 'react-router-dom'
import {connect} from 'react-redux'
import {userIsAuthenticatedRedir, userIsNotAuthenticatedRedir, userIsAuthenticated, userIsNotAuthenticated} from './utils/auth'

import Home from './Component/Homepage';
import LoginComponent from './Component/Login';
import DashboardComponent from './Component/Home';
import CreateCardComponent from './Component/CreateCard';

import {logout} from "./redux/actions/user"

const Login = userIsNotAuthenticatedRedir(LoginComponent)
const Dashboard = userIsAuthenticatedRedir(DashboardComponent)
const CreateCard = userIsAuthenticatedRedir(CreateCardComponent)

const LoginLink = userIsNotAuthenticated(() => <li>
  <NavLink className={'deep-purple-text lighten-1 bold'} to="/login">Login</NavLink>
</li>)
const CreateCardLink = userIsAuthenticated(() => <li>
  <NavLink to='/create' className={'deep-purple lighten-1 btn'}>Create Card</NavLink>
</li>)
const LogoutLink = userIsAuthenticated(({logout}) => <li>
  <a className={'deep-purple-text lighten-1 bold'} onClick={() => logout()}>Logout</a>
</li>)

function App({user, logout}) {
  return (<Router>
    <div>
      <nav>
        <div className={"container"}>
          <NavLink to="/dashboard" className={"brand-logo"}>
            <img alt={"logo"} src={"/logo.svg"}/>
          </NavLink>
          <ul className={"right hide-on-med-and-down"}>
            <CreateCardLink/>
            <LoginLink/>
            <LogoutLink logout={logout}/>
          </ul>
        </div>
      </nav>

      <div>
        <Route exact={true} path="/" component={Home}/>
        <Route path="/login" component={Login}/>
        <Route path="/dashboard" component={Dashboard}/>
        <Route path="/create" component={CreateCard}/>
      </div>
    </div>
  </Router>)
}

const mapStateToProps = state => ({user: state.user})

export default connect(mapStateToProps, {logout})(App)



// WEBPACK FOOTER //
// ./src/App.js